import { Controller } from "@hotwired/stimulus"

// Ouverture / fermeture générique d'une o-modal (remplace Bootstrap Modal).
//   - placé sur l'élément .o-modal
//   - data-modal-trigger-value : sélecteur CSS des déclencheurs externes (clic → ouvre)
//   - boutons de fermeture : data-action="click->modal#close"
//   - clic sur le fond : data-action="click->modal#backdrop"  (sur l'élément .o-modal)
//   - touche Échap : ferme
export default class extends Controller {
  static values = { trigger: String }

  connect() {
    this.boundOpen = this.open.bind(this)
    this.boundEscape = this.escape.bind(this)
    this.triggers = this.triggerValue ? document.querySelectorAll(this.triggerValue) : []
    this.triggers.forEach((trigger) => trigger.addEventListener("click", this.boundOpen))
  }

  disconnect() {
    this.triggers.forEach((trigger) => trigger.removeEventListener("click", this.boundOpen))
    document.removeEventListener("keydown", this.boundEscape)
  }

  open(event) {
    if (event) event.preventDefault()
    this.element.classList.add("is-open")
    document.addEventListener("keydown", this.boundEscape)
  }

  close(event) {
    if (event) event.preventDefault()
    this.element.classList.remove("is-open")
    document.removeEventListener("keydown", this.boundEscape)
  }

  backdrop(event) {
    if (event.target === this.element) this.close()
  }

  escape(event) {
    if (event.key === "Escape") this.close()
  }
}
